const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-js-api';
const GOOGLE_MAPS_CALLBACK = '__swaGoogleMapsLoaded';
const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY;

let loadPromise = null;

function mapsApiReady() {
	return !!(
		window.google
		&& window.google.maps
		&& typeof window.google.maps.Map === 'function'
		&& typeof window.google.maps.OverlayView === 'function'
		&& window.google.maps.geometry
	);
}

function injectMapsScript() {
	return new Promise((resolve, reject) => {
		if (mapsApiReady()) {
			resolve();
			return;
		}

		const existing = document.getElementById(GOOGLE_MAPS_SCRIPT_ID);
		if (existing) {
			// Script tag exists but API may still be loading, or a prior HMR left a stub.
			const started = Date.now();
			const timer = setInterval(() => {
				if (mapsApiReady()) {
					clearInterval(timer);
					resolve();
				} else if (Date.now() - started > 15000) {
					clearInterval(timer);
					reject(new Error('Timed out waiting for Google Maps JavaScript API'));
				}
			}, 50);
			return;
		}

		window[GOOGLE_MAPS_CALLBACK] = () => {
			delete window[GOOGLE_MAPS_CALLBACK];
			if (mapsApiReady()) {
				resolve();
			} else {
				reject(new Error('Google Maps loaded without required constructors'));
			}
		};

		const script = document.createElement('script');
		script.id = GOOGLE_MAPS_SCRIPT_ID;
		script.src = [
			'https://maps.googleapis.com/maps/api/js',
			`?key=${encodeURIComponent(GOOGLE_MAPS_API_KEY)}`,
			'&loading=async',
			'&libraries=geometry',
			`&callback=${GOOGLE_MAPS_CALLBACK}`
		].join('');
		script.async = true;
		script.defer = true;
		script.onerror = () => {
			delete window[GOOGLE_MAPS_CALLBACK];
			script.remove();
			reject(new Error('Failed to load Google Maps JavaScript API'));
		};
		document.head.appendChild(script);
	});
}

/**
 * Lazily injects the Google Maps JavaScript API (geometry library included).
 * Uses the classic callback loader so OverlayView/Map are available for
 * ProjectedOverlay + geoxml3. Safe to call multiple times.
 */
export default function loadGoogleMaps() {
	if (loadPromise) {
		return loadPromise;
	}

	if (!GOOGLE_MAPS_API_KEY) {
		return Promise.reject(
			new Error('GOOGLE_MAPS_API_KEY is not set. Copy .env.example to .env and rebuild.')
		);
	}

	loadPromise = injectMapsScript()
		.then(() => window.google.maps)
		.catch((err) => {
			loadPromise = null;
			throw err;
		});

	return loadPromise;
}
